import { render, staticRenderFns } from "./AddFields.vue?vue&type=template&id=783b536a&scoped=true"
import script from "./AddFields.vue?vue&type=script&lang=js"
export * from "./AddFields.vue?vue&type=script&lang=js"
import style0 from "./AddFields.vue?vue&type=style&index=0&id=783b536a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783b536a",
  null
  
)

export default component.exports